var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import FormInput from '@shared/forms/FormInput';
import { Forms } from '@shared/forms/Forms';
import TextInput from '@shared/input/TextInput';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { UsersFilter } from '../../../../../../../common/api/models';
import { useCreateServiceUser, useCreateUser } from '../../../../data/user/userActions';
import { Copy } from '../../../../shared/icons/icons';
import SelectInput from '../../../../shared/input/SelectInput';
import ModalHeader from '../../../../shared/modal/ModalHeader';
import { FormFieldLabel } from '../../../../styled/Form';
import { ModalBody } from '../../../../styled/Modal';
var NEW_SERVICE_USER_VALUES = { name: '' };
var NEW_KEYCLOAK_USER_VALUES = { firstName: '', lastName: '', email: '', password: '', confirmPassword: '' };
var SPACE_BETWEEN_CONTAINER = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 15,
};
function UserModal() {
    var L = useLanguage().L;
    var _a = __read(useState(UsersFilter.Keycloak), 2), userType = _a[0], setUserType = _a[1];
    var isServiceUser = userType === UsersFilter.Service;
    return (React.createElement(Modal, { width: 500 },
        React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
            } },
            React.createElement(ModalHeader, { title: L(isServiceUser ? 'Create service user' : 'Create user') }),
            React.createElement(ModalBody, null,
                React.createElement(FormFieldLabel, null, L('User type')),
                React.createElement(SelectInput, { value: userType, options: [
                        { value: UsersFilter.Keycloak, label: L('STANDARD') },
                        { value: UsersFilter.Service, label: L('SERVICE') },
                    ], onChange: function (e) { return setUserType(e.target.value); } }),
                isServiceUser ? React.createElement(ServiceUserForm, null) : React.createElement(KeycloakUserForm, null)))));
}
function ServiceUserForm() {
    var L = useLanguage().L;
    var createServiceUser = useCreateServiceUser();
    function submitHandler(values, actions) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, createServiceUser.mutateAsync(values)];
                    case 1:
                        data = _a.sent();
                        toast.success(L('Service user created'));
                        Manager.closeModal();
                        Manager.renderModal(React.createElement(ApiKeyModal, { serviceUserName: values.name, apiKey: data.value }));
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        toast.error(L('Failed to create service user and api key'));
                        return [3 /*break*/, 4];
                    case 3:
                        actions.setIsSubmitting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function validate(values) {
        var errors = {};
        if (!values.name) {
            errors.name = L('Service user name is required');
        }
        return errors;
    }
    return (React.createElement(Forms, { initialValues: __assign({}, NEW_SERVICE_USER_VALUES), onSubmit: submitHandler, validation: validate }, function (_a) {
        var errors = _a.errors, values = _a.values, isSubmitting = _a.isSubmitting, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
        return (React.createElement("form", { onSubmit: handleSubmit },
            React.createElement("div", { style: {
                    display: 'grid',
                    paddingTop: 30,
                    paddingBottom: 30,
                    flexGrow: 1,
                } },
                React.createElement(TextInput, { name: "name", label: L('Name'), value: values.name, invalidString: errors.name, onChange: handleChange, bottomMargin: true }),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                    React.createElement(FSButton, { "$type": "tertiary", type: "button", title: "Close", onClick: Manager.closeModal, style: { marginRight: 30 } }),
                    React.createElement(FSButton, { loading: isSubmitting, title: "Create", type: "submit" })))));
    }));
}
function KeycloakUserForm() {
    var L = useLanguage().L;
    var createKeycloakUser = useCreateUser();
    function submitHandler(values, actions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                createKeycloakUser.mutate(values, {
                    onSuccess: function () {
                        toast.success(L('User created'));
                        Manager.closeModal();
                    },
                    onError: function () {
                        toast.error(L('Failed to create user'));
                    },
                    onSettled: function () {
                        actions.setIsSubmitting(false);
                    },
                });
                return [2 /*return*/];
            });
        });
    }
    function validate(values) {
        var errors = {};
        if (!values.lastName) {
            errors.lastName = L('Last name is required');
        }
        if (!values.firstName) {
            errors.firstName = L('First name is required');
        }
        if (!values.email) {
            errors.email = L('Email is required');
        }
        if (!values.password) {
            errors.password = L('Password is required');
        }
        if (values.password !== values.confirmPassword) {
            errors.confirmPassword = L('Password incorrect');
        }
        return errors;
    }
    return (React.createElement(Forms, { initialValues: __assign({}, NEW_KEYCLOAK_USER_VALUES), onSubmit: submitHandler, validation: validate }, function (_a) {
        var errors = _a.errors, values = _a.values, isSubmitting = _a.isSubmitting, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
        return (React.createElement("form", { onSubmit: handleSubmit },
            React.createElement("div", { style: {
                    display: 'grid',
                    flexGrow: 1,
                    paddingTop: 30,
                    paddingBottom: 30,
                } },
                React.createElement("div", { style: SPACE_BETWEEN_CONTAINER },
                    React.createElement(TextInput, { name: "firstName", label: L('First Name'), value: values.firstName, invalidString: errors.firstName, onChange: handleChange, bottomMargin: true }),
                    React.createElement(TextInput, { name: "lastName", label: L('Last Name'), value: values.lastName, invalidString: errors.lastName, onChange: handleChange, bottomMargin: true })),
                React.createElement(TextInput, { name: "email", label: L('Email'), value: values.email, invalidString: errors.email, onChange: handleChange, bottomMargin: true }),
                React.createElement(TextInput, { type: "password", label: L('Password'), name: "password", value: values.password, invalidString: errors.password, onChange: handleChange, bottomMargin: true }),
                React.createElement(TextInput, { type: "password", label: L('Confirm Password'), name: "confirmPassword", value: values.confirmPassword, invalidString: errors.confirmPassword, onChange: handleChange, bottomMargin: true }),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                    React.createElement(FSButton, { "$type": "tertiary", title: "Close", onClick: Manager.closeModal, style: { marginRight: 30 } }),
                    React.createElement(FSButton, { disabled: isSubmitting, title: "Submit", type: "submit" })))));
    }));
}
function ApiKeyModal(props) {
    var L = useLanguage().L;
    var apiKey = props.apiKey, serviceUserName = props.serviceUserName;
    return (React.createElement(Modal, { width: 650 },
        React.createElement(ModalHeader, { title: L('Service user') + ' ' + serviceUserName + ' ' + L('api key created') }),
        React.createElement(ModalBody, null,
            React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'auto 50px', gap: 10, alignItems: 'center' } },
                React.createElement(FormInput, { label: L('Api key'), value: apiKey, disabled: true, type: "text", name: "apiKey" }),
                React.createElement("button", { style: {
                        marginTop: 22,
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'white',
                        appearance: 'none',
                    }, onClick: function () {
                        window.navigator.clipboard.writeText(apiKey);
                        toast.success(L('Api key copied to clipboard'));
                    } },
                    React.createElement(Copy, null)))),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end', padding: 30, paddingTop: 0 } },
            React.createElement(FSButton, { title: "OK", onClick: Manager.closeModal }))));
}
export default UserModal;
